import { render, staticRenderFns } from "./BeerDash.vue?vue&type=template&id=64cc71b0&"
import script from "./BeerDash.vue?vue&type=script&lang=js&"
export * from "./BeerDash.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/components/beer-dash.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports